import React, { useState } from "react";
import { message, Alert } from "antd";
import CriticalActionModal from "./CriticalActionModal";
import { reverseCancelInfraction } from "../api/infractions/infractionRequest";

/**
 * Suggestion 5 — Reverse an infraction cancellation (canceled → pending).
 */
const ReverseCancelInfractionModal = ({ visible, onCancel, onSuccess, infraction }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async (reason) => {
    if (!infraction) return;
    setLoading(true);
    try {
      const response = await reverseCancelInfraction(infraction.id, reason);
      if (response?.success) {
        message.success(response.message || "Annulation inversée avec succès");
        onSuccess?.(response.data);
      } else {
        message.error(response?.message || response?.error || "Erreur lors de l'opération");
      }
    } catch (error) {
      message.error(error.response?.data?.error || error.response?.data?.message || "Erreur lors de l'inversion de l'annulation");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CriticalActionModal
      visible={visible}
      onCancel={onCancel}
      onConfirm={handleConfirm}
      loading={loading}
      title="Inverser l'annulation de l'infraction"
      okText="Réactiver l'infraction"
      summaryItems={[
        { label: "Infraction", to: infraction?.reference || `#${infraction?.id ?? ""}` },
        { label: "Statut", from: "Annulé", to: "En attente" },
      ]}
      warningBanner={
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 8 }}
          message="Action critique"
          description="Cette action réactivera une infraction annulée (retour en attente) et effacera les informations d'annulation (date, agent, motif)."
        />
      }
    />
  );
};

export default ReverseCancelInfractionModal;
